import { TimesheetOpenShiftFragment } from 'generated/resources/graphql'
import moment from 'moment'
import { DeepPartial } from 'utility-types'

import { convertDate, stringToDate } from 'modules/core/lib/dates'

import { clockIn, isAutomaticBreak } from './ShiftConcern'

class OpenShiftUtils {
  static duration(
    openShift?:
      | (Pick<TimesheetOpenShiftFragment, 'clockIn' | 'date'> & DeepPartial<TimesheetOpenShiftFragment>)
      | null
  ): number {
    const clockInTime = this.clockIn(openShift)
    return openShift ? Math.floor(moment.duration(moment().diff(clockInTime)).as('minutes')) : 0
  }

  static date(
    openShift?: (Pick<TimesheetOpenShiftFragment, 'date'> & DeepPartial<TimesheetOpenShiftFragment>) | null
  ) {
    return !!openShift ? stringToDate(openShift.date, 'backend') : null
  }

  static clockIn(
    openShift?:
      | (Pick<TimesheetOpenShiftFragment, 'clockIn' | 'date'> & DeepPartial<TimesheetOpenShiftFragment>)
      | null
  ) {
    return openShift ? clockIn(openShift.clockIn, openShift.date) : null
  }

  static isAutomaticBreak(
    openShift?:
      | (Pick<TimesheetOpenShiftFragment, 'workable' | 'automaticClockIn'> &
          DeepPartial<TimesheetOpenShiftFragment>)
      | null
  ): boolean {
    return openShift ? isAutomaticBreak(openShift.workable, openShift.automaticClockIn) : false
  }

  static openShiftLastClockInDate(openShift: TimesheetOpenShiftFragment) {
    const combinedOpenShiftDateTime = openShift
      ? `${moment.utc(openShift.date).format('YYYY-MM-DD')}T${moment
          .utc(openShift.clockIn)
          .format('HH:mm')}`
      : undefined
    if (!combinedOpenShiftDateTime) return

    return convertDate(combinedOpenShiftDateTime, 'backend_datetime', 'ui_time_date_dm')
  }
}

export default OpenShiftUtils
